import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  settingsContainer: {
    padding: "20px",
  },
  settingsSection: {
    marginBottom: "24px",
  },
});